import script from "./Terms.vue?vue&type=script&setup=true&lang=ts"
export * from "./Terms.vue?vue&type=script&setup=true&lang=ts"

import "./Terms.vue?vue&type=style&index=0&id=5b91deea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b91deea"]])

export default __exports__